<template>
    <div>
        <v-col class="my-0 py-0 px-0 px-md-8 pb-15">
            <v-col class="text-start mt-5 pb-0">
                <v-alert text dense color="#8061c2" border="left" class="pl-5">
                    <h1 class="title mt-1">Monetización</h1>
                    <p class="desc mt-0 mb-1">Modifica la monetización de los harmonys.</p>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total monetizados: &nbsp; <strong>{{ totals.monetization }}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total sin monetización: &nbsp; <strong>{{ totals.NoMonetization }}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total clics únicos: &nbsp; <strong>{{ totals.uniqueClicks }}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total vistas únicas: &nbsp; <strong>{{totals.viewsUnique}}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total publicidad activa: &nbsp; <strong>{{ totals.adsActive }}</strong></v-chip>
                    <v-chip
                    class="mt-2 mr-2"
                    color="#8061c2"
                    label
                    outlined
                    >Total publicidad inactiva: &nbsp; <strong>{{ totals.adsInactive }}</strong></v-chip>
                </v-alert>
            </v-col>

            <!-- Search Bar y Filtros -->
            <v-row class="mx-3">
                <v-col cols="12" md="4" class="px-0">
                    <v-text-field v-model="searchTable" color="#8061c2" label="Buscar" append-icon="mdi-magnify"
                        single-line hide-details outlined class="mb-2 mx-0 px-0"></v-text-field>
                </v-col>

                <v-col cols="12" md="2" class="pl-md-2 px-0">
                    <v-select v-model="filter" :items="filterOptions" label="Filtrar por" outlined
                        hide-details></v-select>
                </v-col>

                <v-col cols="12" md="2" class="px-md-2 px-0">
                    <v-select v-model="filterAdsD" :items="filterAds" label="Filtrar por publicidad" outlined/>
                </v-col>
                <v-col cols="12" md="2" class="pr-md-2 px-0">
                    <v-select v-model="filterMonetization" :items="filterMonetizations" label="Filtrar por monetización" outlined></v-select>
                </v-col>
                <v-col cols="12" md="2" class="px-0 ">
                    <v-select v-model="order" :items="orderOptions" label="Ordenar" outlined hide-details></v-select>
                </v-col>
            </v-row>

            <!-- Tabla de datos -->
            <v-data-table :headers="headers" :items="harmonys" :loading="loading" class="elevation-1 mx-3 px-2 py-4"
                :items-per-page="perPage" :server-items-length="totalSites" :page.sync="page" :footer-props="{
                    itemsPerPageOptions: [50, 100, 200, 300, -1], 
                    showFirstLastPage: true
                }" @update:page="fetchHarmonys" @update:items-per-page="changePerPage">
                <!-- Columnas y Templates -->
                <template v-slot:item.logo_path="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-avatar size="35" class="clickable-avatar" @click="showLogo(item.logo_path)"
                                @mouseover="hoveredLogo = item.logo_path" @mouseleave="hoveredLogo = null"
                                v-bind="attrs" v-on="on">
                                <v-img :src="item.logo_path" v-if="item.logo_path"></v-img>
                                <v-img :src="require('../../assets/illustrations/no-photo.jpg')" v-else></v-img>
                            </v-avatar>
                        </template>
                        <span>Ver Imagen</span>
                    </v-tooltip>
                </template>

                <template v-slot:item.visits="{ item }">
                    {{ item.abbreviated_visits || 0 }}
                </template>

                <template v-slot:item.name="{ item }">
                    {{ item.name }}
                </template>

                <template v-slot:item.ads="{ item }">
                    <v-chip
                    color="green"
                    text-color="white"
                    small
                    v-if="item.ads == '1' || item.ads == true"
                    >
                    Activa
                    </v-chip>

                    <v-chip
                    color="#9b9b9b"
                    text-color="white"
                    small
                    v-else
                    >
                    Inactiva
                    </v-chip>
                </template>

                <template v-slot:item.monetization_type_names="{item}">
                    {{ nameMonetization(item.monetization_type_names) }}
                </template>

                <!-- Botones de acciones -->
                <template v-slot:item.actions="{ item }">
                    <!-- Botón para estadísticas -->

                    <v-tooltip bottom>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn icon color="green" v-bind="attrs" v-on="on" @click="goToHarmony(item.slug)">
                                <v-icon>mdi-web</v-icon>
                            </v-btn>
                        </template>
                        <span>Ir al Harmony</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{on, attrs}">
                            <v-btn icon color="rgb(128 97 194)" v-bind="attrs" v-on="on" @click="impersonateUser(item.user_id)">
                                <v-icon>mdi-account-switch</v-icon>
                            </v-btn>
                        </template>
                        <span>Impersonar Usuario</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon :color="item.monetization_type_names.includes('no_monetize') ? 'red' : '#4caf50'" v-bind="attrs" v-on="on" @click="openEditDialog(item)">
                                <v-icon size="35">mdi-cash-edit</v-icon>
                            </v-btn>
                        </template>
                        <span>Modificar <br>Monetizacion</span>
                    </v-tooltip>
                </template>
            </v-data-table>


            <MonetizationEdit
            :dialogShow.sync="editDialog"
             @close="editDialog = false"
            :idHarmony="harmonyInfo.idHarmony"
            :harmonyName.sync="harmonyInfo.harmonyName"
            :harmonyTypeMonetization.sync="harmonyInfo.harmonyTypeMonetization"
            :linksHarmony.sync="harmonyInfo.linksHarmony"
            :linksHarmonyMonetizable.sync="harmonyInfo.linksHarmonyMonetizable"
            :typesMonetization="typesMonetization"
            :ads.sync="ads"
            @update-monetization="updatedMonetization"
            />

            <!-- Modal para ampliar el logo -->
            <v-dialog v-model="dialog" max-width="14rem" class="rounded-lg">
                <v-img :src="selectedLogo" width="14rem"></v-img>
            </v-dialog>
        </v-col>
    </div>
</template>

<script>
import axios from '@/axios.js';
import debounce from 'lodash/debounce';
import impersonationMixin from '@/mixins/impersonationMixin';
import MonetizationEdit from '../../components/partials/admin/MonetizationEdit.vue';
import harmonyMixin from '../../mixins/harmonyMixin';

export default {
    name: "Harmonys",
    mixins: [impersonationMixin, harmonyMixin],
    components: {
        MonetizationEdit
    },
    data() {
        return {
            harmonys: [],
            search: '',  // Término de búsqueda
            loading: true,
            dialog: false,
            slug: '',
            selectedLogo: null,
            page: 1,
            perPage: 50,
            totalSites: 0,
            totalSitesMonetization: 0,
            totalViewsUnique: 0,
            totalUniqueClick: 0,
            totalNoMonetization: 0,
            totalAdsActive: 0,
            totalAdsInactive: 0,
            order: 'desc',  // Orden por defecto
            filter: 'created_at',  // Filtro por defecto
            filterAdsD: 'all',
            filterMonetization: 'all',
            editDialog: false,
            ads: false,
            typesMonetization: [
                { text: 'Clicks Únicos', value: 'unique_clicks' },
                { text: 'Vistas Únicas', value: 'unique_views' },
                { text: 'Sin Monetización', value: 'no_monetize' }
            ],

            headers: [
                { text: 'Logo', value: 'logo_path', align: 'start', sortable: false },
                { text: 'Nombre', value: 'site_name', align: 'start' },
                { text: 'Creador', value: 'user_email' },
                { text: 'Visitas', value: 'total_visits', sortable: true },
                { text: 'Publicidad', value: 'ads', sortable: true },
                { text: 'Monetización', value: 'monetization_type_names', sortable: true },
                { text: 'Acciones', value: 'actions', sortable: false }
            ],
            orderOptions: [
                { text: 'Mayor', value: 'desc' },
                { text: 'Menor', value: 'asc' }
            ],
            filterOptions: [
                { text: 'Fecha Creación', value: 'created_at' },
                { text: 'Vistas', value: 'views' }
            ],
            filterAds:[
                {text: 'Todos', value: 'all'},
                {text: 'Activa', value: '1'},
                {text: 'Inactiva', value: '0'}
            ],
            filterMonetizations:[
                {text: 'Todos', value: 'all'},
                {text: 'Vistas únicas', value: 'unique_views'},
                {text: 'Clics únicos', value: 'unique_clicks'},
                {text: 'Sin monetización', value: 'no_monetize'}
            ],
            harmonyInfo: {
                harmonyName: '',
                idHarmony: 0,
                harmonyTypeMonetization: [],
                linksHarmony: [],
                linksHarmonyMonetizable: [],
                ad: false
            }
        };
    },

    watch: {
        order(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchHarmonys();
            }
        },
        filter(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.fetchHarmonys();
            }
        },
        filterAdsD(newVal, oldVal){
            if(newVal !== oldVal){
                this.fetchHarmonys();
            }
        },
        filterMonetization(newVal, oldVal){
            if(newVal !== oldVal){
                this.fetchHarmonys();
            }
        }
    },
    computed: {
        searchTable: {
            get() { return this.search },
            set: debounce(function (value) {
                this.search = value
                this.fetchHarmonys();
            }, 400)
        },
        totals(){
            const monetization = Number(this.totalSitesMonetization);
            const uniqueClicks = Number(this.totalUniqueClick);
            const viewsUnique = Number(this.totalViewsUnique);
            const NoMonetization = Number(this.totalNoMonetization);
            const adsActive = Number(this.totalAdsActive);
            const adsInactive = Number(this.totalAdsInactive);

            const allValid = [monetization, uniqueClicks, viewsUnique, NoMonetization, adsActive, adsInactive].every(v => !isNaN(v));

            if(allValid){
                return{
                    monetization: monetization.toLocaleString('en-US'),
                    uniqueClicks: uniqueClicks.toLocaleString('en-US'),
                    viewsUnique: viewsUnique.toLocaleString('en-US'),
                    NoMonetization: NoMonetization.toLocaleString('en-US'),
                    adsActive: adsActive.toLocaleString('en-US'),
                    adsInactive: adsInactive.toLocaleString('en-US')
                }
            }else{
                return{
                    monetization: '0',
                    uniqueClicks: '0',
                    viewsuUnique: '0',
                    NoMonetization: '0',
                    adsActive: '0',
                    adsInactive: '0'
                }
            }
        }
    },
    created() {
        this.initializeSearch();
        this.fetchHarmonys();
        this.$i18n.locale = 'es';
    },
    methods: {
        async updatedMonetization(harmonyTypeMonetization, linksHarmonyMonetizable, idHarmony, ads) {
            try {
                const response = await axios.post('/admin/update-site-monetization', {
                    site_id: idHarmony,
                    monetization_type_names: harmonyTypeMonetization,
                    links_monetizable: linksHarmonyMonetizable,
                    ad: ads
                });
                if (response.data.success) {
                    this.editDialog = false;
                    this.fetchHarmonys();
                    this.$vs.notify({
                        title: 'Éxito',
                        text: 'Monetización actualizada correctamente',
                        color: 'success',
                        icon: 'check_box',
                        position: 'bottom-center',
                        time: 5000,
                    });
                }

            } catch (error) {
                this.$vs.notify({
                    title: 'Error',
                    text: 'Error al actualizar la monetización',
                    color: 'danger',
                    icon: 'error',
                    position: 'bottom-center',
                    time: 5000,
                });
                console.error(error);
            }
        },

        openEditDialog(harmony) {
            this.ads = false
            this.harmonyInfo.idHarmony = harmony.site_id;
            this.harmonyInfo.harmonyTypeMonetization = harmony.monetization_type_names.split(',').map(mon => mon.trim());
            this.harmonyInfo.linksHarmony = harmony.links;
            this.harmonyInfo.linksHarmonyMonetizable = harmony.links_monetizable;
            this.harmonyInfo.harmonyName = harmony.site_name;
            this.ads = harmony.ads == '1' || harmony.ads == true  ? true : false
            this.editDialog = true;
        },

        initializeSearch() {
            const searchQuery = this.$route.query.search;
            if (searchQuery) {
                this.search = searchQuery;
            }
        },

        async fetchHarmonys() {
            this.loading = true;
            try {
                const response = await axios.get('/admin/get-sites-monetization', {
                    params: { 
                        page: this.page, 
                        per_page: this.perPage,
                        search: this.search ,
                        order: this.order,
                        filter: this.filter,
                        filterAdsD: this.filterAdsD,
                        filterMonetization: this.filterMonetization
                    }
                });

                this.harmonys = response.data.data;
                this.totalSites = response.data.total;
                this.totalUniqueClick = response.data.totalUniqueClick;
                this.totalSitesMonetization = response.data.totalSitesMonetization;
                this.totalViewsUnique = response.data.totalViewsUnique;
                this.totalNoMonetization = response.data.totalNoMonetization;
                this.totalAdsActive = response.data.totalAdsActive;
                this.totalAdsInactive = response.data.totalAdsInactive;
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        changePerPage(newPerPage) {
            this.perPage = newPerPage;
            this.page = 1;
            this.fetchHarmonys();
        },

        showLogo(logoPath) {
            this.selectedLogo = logoPath ? logoPath : require('../../assets/illustrations/no-photo.jpg');
            this.dialog = true;
        },

        getStatusColor(statusId) {
            switch (statusId) {
                case 1: return 'orange';
                case 2: return 'gray';
                case 3: return 'rgb(101 201 105)';
                case 4: return '#ff756a';
                default: return 'blue';
            }
        },

        goToLinks(slug){
            const routeData = this.$router.resolve({
                name: 'Links',
                query: { search: slug }
            });

            window.open(routeData.href, '_blank');
        },
        nameMonetization(monetization) {
            return monetization.split(',').map(mon => {
                switch (mon.trim()) {
                    case 'unique_clicks':
                        return 'Clicks Únicos';
                    case 'unique_views':
                        return 'Vistas Únicas';
                    case 'no_monetize':
                        return 'Sin Monetización';
                    default:
                        return mon.trim();
                }
            }).join(', ');
        },

    }
};
</script>

<style scoped>
.title {
    font-size: 22px !important;
    color: #8061c2;
}

.description-news {
    color: #7C7C7C;
    font-weight: 400;
    font-size: 14px;
}

.desc {
    color: #737373;
    font-size: 15px;
}

.clickable-avatar:hover {
    transform: scale(1.2);
    transition: transform 0.3s ease;
}

.title-emails {
    color: #737373;
    font-weight: 800;
    font-size: 20px;
}

.harmony-name {
    color: #8061c2;
    font-weight: 800;
    font-size: 18px;
}
</style>
